import React from 'react';
import PropTypes from 'prop-types';

import { H3 } from 'components/core/Typography';
import { Stars } from 'components/review/Stars';
import { Review } from 'components/brand/ReviewSection';
import { reviewsPageTypes } from './PLPReviewSectionOptions';

import './PLPReviewSection.scss';


export function PLPReviewSection({pageType}) {
	return (
		<div className="reviews-section" id='reviews-section'>
			<div className="section-content">
				<div className="reviews-intro">
					<Stars rating={4.3} outOf={5} size="medium" />
					<H3 weight="ultraBold" color="white">
						SpareFoot has a 4.3 out of 5 star rating from over <br /> 46,000 customer reviews on TrustPilot!
					</H3>
				</div>
				<div className="reviews-content">
					{reviewsPageTypes[pageType].map((review) => (
						<Review {...review} key={review.reviewerInitials} />
					))}
				</div>
			</div>
		</div>
	);
}

PLPReviewSection.propTypes = {
    pageType: PropTypes.string
};

export default PLPReviewSection;
